import React, { useState } from "react";
import { Table } from "reactstrap";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";

import style from "../Grid.module.scss";

const page = 10;

const renderFootprint = (f) => {
  const initial = ` - ${parseInt(f.EventAccountDebitCredit, 10) > 0 ? "Credit " : "Debit "}`;
  let end = ` ${f.EventAccountTicker}`;
  if (f.EventAccountIsCommission) {
    end += " Commission";
  } else if (f.EventAccountIsTax) {
    end += " Tax";
  } else if (f.EventAccountIsFee) {
    end += " Fee";
  } else if (f.EventAccountIsWithholding) {
    end += " Withholding";
  }
  return (
    <React.Fragment>
      {initial}
      <FormattedNumber value={f.EventAccountDebitCreditVolume} dataTypeDecimalName="currency" />
      {end}
    </React.Fragment>
  );
};

const CorpEventAccounts = ({ accounts }) => {
  const [activeAccounts, setActiveAccounts] = useState(accounts.length > page ? page : accounts.length);
  const [collapsedAccount, setCollapsedAccount] = useState(accounts.map(() => false));

  const handleMore = () =>
    setActiveAccounts(accounts.length > activeAccounts + page ? activeAccounts + page : accounts.length);

  const handleCollapse = (index) =>
    setCollapsedAccount((oldCollapse) => {
      const newColl = [...oldCollapse];
      newColl[index] = !newColl[index];
      return newColl;
    });

  const showAccounts = accounts.slice(0, activeAccounts);
  return (
    <div className={style.grid}>
      <h6 className="my-3">Accounts</h6>
      <Table responsive hover>
        <thead>
          <tr>
            <th>Name</th>
            <th>Account Type</th>
            <th>Balance Type</th>
            <th>Portfolio</th>
          </tr>
        </thead>
        <tbody>
          {showAccounts.map((acc, accIndex) => (
            <React.Fragment key={acc.BasicAccountId}>
              <tr style={{ cursor: "pointer" }} onClick={() => handleCollapse(accIndex)}>
                <td className="font-weight-bold">{acc.BasicAccountName}</td>
                <td className="font-weight-bold">{acc.BasicAccountType}</td>
                <td className="font-weight-bold">{acc.EventBalanceType}</td>
                <td className="font-weight-bold">
                  <FormattedNumber value={acc.EventAccountAmount} dataTypeDecimalName="currency" />
                </td>
              </tr>
              {collapsedAccount[accIndex] &&
                acc.Footprint.map((footprint) => (
                  <tr key={`acc${acc.BasicAccountId}foot${footprint.EventAccountFootprintId}`}>
                    <td colSpan={8}>{renderFootprint(footprint)}</td>
                  </tr>
                ))}
            </React.Fragment>
          ))}
          {accounts.length === 0 && (
            <tr>
              <td colSpan={8} style={{ textAlign: "center" }}>
                No Accounts
              </td>
            </tr>
          )}
          {accounts.length > activeAccounts && (
            <tr>
              <td style={{ cursor: "pointer" }} onClick={handleMore} colSpan={8}>
                Show More Accounts
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default CorpEventAccounts;
